module.exports = __webpack_public_path__ + "img/2.b62e24ed.jpg";